<script setup lang="ts">
import type { CraftImageProps } from '@studio-fes/layer-craft/app/components/CraftImage.vue'
import type { MediaFragment } from '#graphql-operations'

interface HeroMediaProps {
  media?: (MediaFragment | null)[]
  imgProps?: CraftImageProps
  captionClass?: string
}

withDefaults(defineProps<HeroMediaProps>(), {
  imgProps: undefined,
  captionClass: '',
})
</script>

<template>
  <figure class="heroMedia layout-grid gap-0">
    <div class="media col-span-full aspect-1 order-last relative lg:col-span-6 xl:col-span-8 lg:aspect-auto lg:top-$header-height lg:sticky">
      <slot name="media">
        <CraftMedia
          v-for="item in media"
          :key="item!.id"
          :media="item"
          :img-props="imgProps"
          class="size-full object-cover lg:inset-0 lg:absolute"
        />
      </slot>
    </div>
    <figcaption class="px-4.5 py-12 col-span-full h-full lg:px-7.5 lg:py-6 lg:col-span-6 xl:col-span-4" :class="captionClass">
      <slot />
    </figcaption>
  </figure>
</template>

<style scoped>
.heroMedia > .media {
  @screen lg {
    height: calc(100svh - var(--header-height));
  }
}

.heroMedia > figcaption {
  min-height: 50svh;

  @screen lg {
    min-height: calc(100svh - var(--header-height));
    height: 100%;
  }
}
</style>
